export { default } from './StockReceiptUpdate';
